<template>
    <div class="setup-theme-page">
        <div class="container">
            <div class="setup-theme-promo">
                <img src="https://admin.sales.bazis.kz/media/bazis-logo_2023.svg" alt="">
                <h2>Здесь скоро будет сайт</h2>
                <h2>Жақында сайт болады</h2>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'setup-theme--page',
        components: {
        },
        data () {
            return {
                projectNameG: window.host,
            }
        },
        methods: {
        },
        created() {
        },
        mounted() {
            setTimeout(() => {
                this.$parent.$refs.topProgress.done();
            }, 300);
        }
    }
</script>

<style lang="scss">
    // @import '@/styles/components/pages/test-theme-page.scss';
    @import '@/styles/components/pages/setup-theme-page.scss';
</style>